import { product_promo_api_methods } from "./product_promo_code_api";
import { product_promo_utility_methods } from "./product_promo_code_helper";

export default {
  data() {
    return ({
      discount_types: [],
      selected_product: null,
      selected_product_id: "",
      selected_base_profile_id: null,
      selected_products: [],
      catalogue_base_profile_id: null,
      is_catalogue_promo: false,
      product_promo_codes: [],
      is_loading: false,
      isLoading: false,
      promo_code_name: "",
      discount_type: "",
      discount_value: 0,
      start_date: null,
      end_date: null,
      usage_limit: 0,
      minimum_order_amount: 0,
      is_active: true,
      promo_errors: {},
      is_editing_product_promo: false,
      editing_product_promo_code_id: null,
      return_to_promo_manager: false,
      return_to_catalogue_promo_manager: false,
      catalogue_promo_codes: [],
    });
  },
  mounted() {
    this.fetch_discount_types();
  },
  computed: {
    min_start_date() {
      return this.get_date_time_local_string(new Date());
    },
    min_end_date() {
      return this.start_date || this.min_start_date;
    },
  },
  watch: {
    start_date(new_value) {
      if (!new_value || !this.end_date) return;
      if (new Date(this.end_date).getTime() < new Date(new_value).getTime()) {
        this.end_date = null;
      }
    },
  },
  methods: {
    ...product_promo_utility_methods,
    ...product_promo_api_methods,
  },
};
